import { render, staticRenderFns } from "./keywordCard.vue?vue&type=template&id=03db91f0&scoped=true&"
import script from "./keywordCard.vue?vue&type=script&lang=ts&"
export * from "./keywordCard.vue?vue&type=script&lang=ts&"
import style0 from "./keywordCard.vue?vue&type=style&index=0&id=03db91f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db91f0",
  null
  
)

export default component.exports